import React, { useState } from "react";
// import Tapeta_01 from "../images/tapeta_01.jpg";
// import Tapeta_02 from "../images/tapeta_02.jpg";
// import Tapeta_03 from "../images/shutterstock_1124255354.jpg";
// import Tapeta_04 from "../images/shutterstock_1654284619.jpg";
// import Tapeta_05 from "../images/shutterstock_337848515.jpg";
import DesktopSettings from "../DesktopSettings";
import Calculator from "./Calculator";
import CalculatorIcon from "./Calculator_Icon";
import Clock from "./Clock";
import DesktopSetingsIcon from "./DesktopSetingsIcon";
import Mp3Icon from "./Mp3Icon";
import Mp3Player from "./Mp3Player";
import Notes from "./Notes";
import NotesIcon from "./Notes_Icon";
import WeatherIcon from "./WeatherIcon";
import WeatherWidget from "./WeatherWidget";

const Desktopik = () => {
  const [showMp3, setShowMp3] = useState(false);
  const [showWeather, setShowWeather] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showCalculator, setShowCalculator] = useState(false);
  const [showDesktopSettings, setShowDesktopSettings] = useState(false);
  const [wallpaper, setWallpaper] = useState();

  // ====   HANDLE DESKTOP IMAGE   =====

  const handleShowHideMp3 = () => {
    setShowMp3(!showMp3);
  };

  const handleShowWeather = () => {
    setShowWeather(!showWeather);
  };

  const handleShowNotes = () => {
    setShowNotes(!showNotes);
  };

  const handleShowCalculator = () => {
    setShowCalculator(!showCalculator);
  };

  const handleShowDesktopSettings = () => {
    setShowDesktopSettings(!showDesktopSettings);
  };

  const handleChangeWallpaper = (desktopImage) => {
    setWallpaper(desktopImage);
  };

  return (
    <>
      <Clock />
      <img className="wallpaper" src={wallpaper} alt="" />
      {/* <DesktopImage /> */}
      <div className="main_container">
        <div className="icon_container">
          <Mp3Icon show={handleShowHideMp3} />
          <WeatherIcon show={handleShowWeather} />
          <NotesIcon show={handleShowNotes} />
          <CalculatorIcon show={handleShowCalculator} />
          <DesktopSetingsIcon show={handleShowDesktopSettings} />
        </div>

        <div className="widgets_container">
          {showMp3 && <Mp3Player />}
          {showWeather && <WeatherWidget />}
          {showCalculator && <Calculator />}
          {/* {<Calculator />} */}
          {showNotes && <Notes />}
          {/* <Notes /> */}
          {showDesktopSettings && (
            <DesktopSettings wallpaper={handleChangeWallpaper} />
          )}
          {/* <DesktopSettings /> */}
        </div>
      </div>
    </>
  );
};

export default Desktopik;
